export const USERID_CHECK_LOGIN = 'USERID_CHECK_LOGIN';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_LOGOUT = 'USER_LOGOUT';
